/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPermission, IRole, createPermissionLevel } from '@rhybus/api/dist/rhybus'
// import { mpfAuthCrudHttp } from '../../ts/mpf-auth-crud-http'
import * as anewRoles from './roles.json'
// import * as secGroups from '../security-groups'
import * as secGroups from './securitygroups'
import { AuthCrudHttp } from '@rhybus/api'
import { rhybusAuthCrudHttp } from '../../api/rhybus-auth-crud-http'
// import { anewAuthCrudHttp } from '../../services/api/anew-auth-crud-http'
import * as XLSX from 'sheetjs-style'
export function ReturnRolePermission(roleType: any) {
  switch (roleType) {
    case "appSuperAdmin": return appSuperAdmin
    case 'appAdmin': return appAdmin
    case "appUser": return appUser
    case "appPrivilegeHigh": return appPrivilegeHigh
    case "appPrivilegeMedium": return appPrivilegeMedium
    case "appPrivilegeLow": return appPrivilegeLow
    default: return appUser
  }
}

const appSuperAdmin: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.RLIST_CATALOG_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.JOBS_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.METADATA_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.USERSTORE_SECURITY_GROUP
  }
]
const appAdmin: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.METADATA_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, true),
    securityGroup: secGroups.USERSTORE_SECURITY_GROUP
  }
]

const appUser: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.METADATA_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP
  },
]

const appPrivilegeHigh: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.METADATA_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.USERSTORE_SECURITY_GROUP
  }
]

const appPrivilegeMedium: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.METADATA_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.USERSTORE_SECURITY_GROUP
  }

]
const appPrivilegeLow: IPermission[] = [
  {
    permissionLevel: createPermissionLevel(true, false, false),
    securityGroup: secGroups.METADATA_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.CONTENT_SECURITY_GROUP
  },
  {
    permissionLevel: createPermissionLevel(true, true, false),
    securityGroup: secGroups.APPLICATION_SECURITY_GROUP
  },
]

// function to create Roles using Sample Roles Json
export async function CreateCPTSRoles(data: any): Promise<void> {
  for (const item of data.default) {
    const _roleName = item?.name.trim()
    const _roleCode = item?.roleCode.trim()
    const roleOwnerSplit = item?.owners.split(',')
    const roleOwner: any = []
    for (const ele of roleOwnerSplit) {
      roleOwner.push(ele.trim())
    }
    const _rolepermission = item?.permissions
    // await DeleteAndInsertRole(roleName, roleOwner,
    // ReturnRolePermission(rolepermission),
    // item?.type, roleCode)
  }
}


export async function DeleteAndInsertRole(roleName: string, roleOwner: any,
  rolePermission: any, roleType: string,
  roleCode: string, extantEsgRoles?: Map<string, IRole>): Promise<void> {
  const roleObject: IRole = {
    name: roleName,
    owners: roleOwner,
    permissions: rolePermission,
    roleCode: roleCode,
    type: roleType
  }

  try {
    await rhybusAuthCrudHttp().AddOrUpdateRole(roleObject)
  } catch (e: any) {
    if (e?.name?.includes('DuplicateError')) {
      return
    }
    if (e?.name?.includes('NotFound')) {
      await rhybusAuthCrudHttp().AddOrUpdateRole(roleObject)
    } else {
      throw e
    }
  }
}


export async function UpdateRoleNameByCode(roleCode: string, newRoleName: string): Promise<void> {
  const allRoles = [...(await rhybusAuthCrudHttp().GetRoles())]
  const existingRole = allRoles.find((role) => role.roleCode === roleCode)
  if (!existingRole) {
    throw new Error(`Role with code "${roleCode}" not found`)
  }
  const roleId: string = existingRole?.roleId as string
  const eTag: string = existingRole?.eTag as string
  if (!roleId || !eTag) {
    throw new Error('Cannot update role: missing roleId or eTag')
  }
  await rhybusAuthCrudHttp().DeleteRole(roleId, eTag)
  const newRole: IRole = {
    name: newRoleName,
    owners: existingRole.owners,
    permissions: existingRole.permissions,
    roleCode: existingRole.roleCode,
    type: existingRole.type
  }
  await rhybusAuthCrudHttp().AddOrUpdateRole(newRole)
}

export async function CreateESGRolesFromExcel(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = async (e) => {
      try {
        const arrayBuffer = e.target?.result as ArrayBuffer
        let processedCount = 0
        let skippedCount = 0
        let existingRolesSkipped = 0
        let updatedCount = 0

        if (arrayBuffer) {
          const allExtantRoles = [...await rhybusAuthCrudHttp().GetRoles("type eq 'DSCA'")]
          const extantEsgRoles: any = new Map<string, IRole>(
            allExtantRoles.map((role): [string, IRole] => [role.roleCode, role])
          )
          // Read data from the first sheet
          const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: 'array' })
          const sheet = workbook.Sheets[workbook.SheetNames[0]]
          const rows: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1 })

          // Skip header row (first row)
          const dataRows = rows.slice(1)

          for (const row of dataRows) {
            if (row.length < 5) {
              skippedCount++
              continue // Skip incomplete rows
            }

            const roleName = String(row[0] || '').trim()
            const roleCode = String(row[1] || '').trim()
            const owners = String(row[2] || '').trim()
            const permissions = String(row[3] || '').trim()
            const type = String(row[4] || '').trim()

            if (!roleName || !roleCode) {
              skippedCount++
              continue // Skip rows without required data
            }

            // Check if role already exists
            if (extantEsgRoles.has(roleCode)) {
              const existingRole = extantEsgRoles.get(roleCode)

              // If role name has changed, update it using UpdateRoleNameByCode
              if (existingRole?.name !== roleName) {
                try {
                  await UpdateRoleNameByCode(roleCode, roleName)
                  updatedCount++
                } catch (updateError) {
                  console.error(`Failed to update role name for "${roleCode}":`, updateError)
                  existingRolesSkipped++
                }
              } else {
                existingRolesSkipped++
              }
              continue
            }
            const roleOwnerSplit = owners.split(',')
            const roleOwner: string[] = []
            for (const ele of roleOwnerSplit) {
              roleOwner.push(ele.trim())
            }
            await DeleteAndInsertRole(roleName, roleOwner,
              ReturnRolePermission(permissions),
              type, roleCode, extantEsgRoles)

            processedCount++
          }
        }
        const successMessage = `ESG Roles processed! Added: ${processedCount} new roles, Updated: ${updatedCount} role names${existingRolesSkipped > 0 ? `, Skipped: ${existingRolesSkipped} unchanged roles` : ''}${skippedCount > 0 ? `, Invalid: ${skippedCount} incomplete rows` : ''}`
        resolve(successMessage)
      } catch (error) {
        console.error('Exception in CreateESGRolesFromExcel', error)
        reject(error)
      }
    }
    reader.onerror = () => {
      reject(new Error('Failed to read Excel file'))
    }

    reader.readAsArrayBuffer(file)
  })
}


export async function RegAFCreateOrUpdateRoles(): Promise<void> {
  await CreateCPTSRoles(anewRoles)
}

//function to Create Specific Role
// export async function DeleteAndInsertRole(roleName: string, roleOwner: any,
//   rolePermission: any, roleType: string,
//   roleCode: string): Promise<void> {
//   const roleObject: IRole = {
//     name: roleName,
//     owners: roleOwner,
//     permissions: rolePermission,
//     roleCode: roleCode,
//     type: roleType
//   }

//   try {
//     const roleExist: IRole = await anewAuthCrudHttp().GetRoleByName(roleName)
//     if (roleExist) {
//       await DeleteRole(roleExist.name)
//       await anewAuthCrudHttp().AddOrUpdateRole(roleObject)
//     }

//   } catch (e) {
//     if (e && e.name.includes('NotFound')) {
//       // Ignore as we are creating new list
//       await anewAuthCrudHttp().AddOrUpdateRole(roleObject)
//     } else throw (e)
//   }

// }

// //function to delete the Role
// export async function DeleteRole(roleName: string) {
//   try {
//     const roleExist: IRole = await anewAuthCrudHttp().GetRoleByName(roleName)
//     if (roleExist) {
//       const Id: string = roleExist?.roleId as string
//       const eTag: string = roleExist?.eTag as string
//       await anewAuthCrudHttp().DeleteRole(Id, eTag)
//     }
//   }
//   catch (error) {
//     //Ignore
//   }
// }

// //function to get RoleDetails by RoleName
// export async function GetRolesDetails(rolename: string): Promise<void> {
//   await anewAuthCrudHttp().GetRoleByName(rolename)
// } 